/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apr_OkInputs */

const en_mk_tut_apr_ok = /** @type {(inputs: Mk_Tut_Apr_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The approval queue empties again and your decision is recorded in the history, with the time and the reason.`)
};

const id_mk_tut_apr_ok = /** @type {(inputs: Mk_Tut_Apr_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrean approval kembali kosong dan keputusan Anda tercatat di riwayat, lengkap dengan waktu dan alasannya.`)
};

/**
* | output |
* | --- |
* | "The approval queue empties again and your decision is recorded in the history, with the time and the reason." |
*
* @param {Mk_Tut_Apr_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apr_ok = /** @type {((inputs?: Mk_Tut_Apr_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apr_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apr_ok(inputs)
	return en_mk_tut_apr_ok(inputs)
});